@let logoVar = logo();
<div [@sidebarAnimation]="this.layoutService.navOpen()? 'open': 'closed'"
     role="dialog"
     aria-modal="false"
     aria-labelledby="nav_main_title"
     class="fixed h-screen top-0 bottom-0 right-0 z-[60] w-full md:w-[400px] bg-white overflow-y-auto lg:bottom-0 shadow-tarif-mobile-button translate-x-full"
     [class]="baseClass">
    @if (logoVar) {
        <div class="flex justify-between items-center bg-grey min-h-16 px-5">
            <s1-image [block]="logoVar"
                       class="cursor-pointer"
                       aria-label="Close Menu"
                       (click)="closeMenu()" />
            <button (click)="closeMenu()" #menuClosingButton aria-label="Close Menu">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </div>
    } @else {
        <div class="flex justify-between items-center bg-grey min-h-16 px-5">
            <button (click)="closeMenu()"  #menuClosingButton aria-label="Close Menu">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </div>
    }
    <div class="px-3">
        <h2 class="sr-only">
            Menu
        </h2>
        @for (group of nav_children(); let isFirst=$first; track group['_uid']) {
            <s1-cms-component [blok]="group" [attr.id]="isFirst ? 'nav_main_title' : null"/>
        }
    </div>
</div>
